import {
  IConversationData,
  IUpdateConversationQuery,
  IConversationResponse,
} from '../../types/conversations/IConversation';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';

export const updateConversationAsync = async (query: IUpdateConversationQuery): Promise<IConversationData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IConversationResponse>(`/timber/api/internal/genesys/conversations/${query.id}`, query)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
